// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--2v7Z9","icon":"icon--2YC8J","button":"button--3zxkS"};